/**
 * 德语
 */
var deDE = {
  locale: 'de-DE',
  Common: {
    pleaseInput: 'Bitte eingeben',
    pleaseSelect: 'Bitte auswählen',
    confirm: 'Bestätigen',
    clear: 'Löschen',
    cancel: 'Abbrechen',
    next: 'Weiter',
    previous: 'Zurück',
    submit: 'Absenden',
    reset: 'Zurücksetzen'
  },
  Exception: {
    emptyData: 'Keine Daten',
    error: 'Seitenfehler. Bitte versuchen Sie es später erneut',
    networkError: 'Netzwerkfehler'
  },
  List: {
    noMoreData: 'Keine weiteren Daten',
    networkError: 'Netzwerkfehler',
    clickRetry: 'Erneut versuchen'
  },
  DateRangePicker: {
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    timeRange: 'Zeitbereich'
  }
};

export { deDE as default };
